/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { RawEvent } from '../../../interface/eventInterface';
import { Tracker } from '../trackers';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: any;
  }
}

export class GTMTracker implements Tracker {
  private gtmIDs: string[];

  constructor(gtmIDs: string[]) {
    console.log('GTM Constructor called with IDs:', gtmIDs);
    if (gtmIDs.length === 0) {
      throw new Error('GTMTracker requires at least one GTM ID.');
    }
    this.gtmIDs = gtmIDs;
  }

  Init(): void {
    console.log('GTMTracker Init called');

    this.injectScript();
  }

  private injectScript() {
    console.log('Injecting GTM script for IDs:', this.gtmIDs);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    console.log('GTM dataLayer initialized:', window.dataLayer);

    this.gtmIDs.forEach(gtmID => {
      (function (w: any, d: any, s: any, l: any, i: any) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', gtmID);
    });
    console.log(`GTM script injected for IDs: ${this.gtmIDs.join(', ')}`);

    window.gtag('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    });
  }

  TrackEvent(_event: RawEvent): void {
    this.gtmIDs.forEach(gtmID => {
      const eventName = (() => {
        switch (_event.eventName) {
          case 'InitiateCheckout':
            return 'checkout_started';
          case 'CustomerContact':
            return 'checkout_contact_info_submitted';
          case 'ShippingAdded':
            return 'checkout_shipping_info_submitted';
          case 'PurchaseAttempt':
            return 'payment_info_submitted';
          case 'Purchase':
            return 'checkout_completed';
          default:
            return _event.eventName;
        }
      })();
      console.log(`Tracking event: ${eventName} for GTM ID: ${gtmID}`, _event);

      window.dataLayer.push({
        event: eventName,
        timeStamp: _event.cart?.UpdatedAt,
        email: _event.cart?.Email,
        phone: _event.cart?.PhoneNumber,
        first_name: _event.cart?.ShippingAddress?.FirstName,
        last_name: _event.cart?.ShippingAddress?.LastName,
        address1: _event.cart?.ShippingAddress?.Address1,
        address2: _event.cart?.ShippingAddress?.Address2,
        city: _event.cart?.ShippingAddress?.City,
        countryCode: _event.cart?.ShippingAddress?.CountryCode,
        provinceCode: _event.cart?.ShippingAddress?.ProvinceCode,
        zip: _event.cart?.ShippingAddress?.Zip,
        orderId: _event.cart?.ID,
        currency: 'USD',
        value: _event.cart?.TotalAmount,
        id: _event.eventId,
        // clientId: _event.cart?.ChannelID,
        url: window.location.href,
        shipping: _event.cart?.Fees,
      });

      console.log(`GTM event sent for GTM ID: ${gtmID}`);
      console.log(window.dataLayer, 'dataLayer');
    });
  }
}
